import { useSearchParam } from "@/common/hooks/useSearchParam";
import { UIFilter } from "@reflag/shared/filter";
import {
  deserializeFilterParam,
  serializeFilterParam,
} from "@reflag/shared/urls";

export function useFilterParam(fallback: UIFilter) {
  return useSearchParam<UIFilter>("filter", {
    fallback,
    serialize: serializeFilterParam,
    deserialize: deserializeFilterParam,
  });
}
